import styles from "../Cadastro.module.css";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, InputLabel } from "@mui/material";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import { HelperText } from "../../../../components/Errors/HelperText";
import { ArtCivil } from "../../../../components/Combobox/ArtCivil";
import { ArtEletrica } from "../../../../components/Combobox/ArtEletrica";
import { FormControlLabel, Checkbox } from "@mui/material";
import {
    TIPOS_COM_RAMO_ATIVIDADE,
    TIPOS_COM_LOTEAMENTO,
    TIPOS_COM_QUANTIDADE_MEDIDORES,
    TIPOS_COM_CARGA_INSTALADA_E_A_INSTALAR,
    TIPOS_COM_PRAZO_LIGACAO_DEFINITIVA,
    TIPOS_COM_AUMENTO_E_PERTURBADORA
} from "../ValidacoesAnalise";

const checkboxSx = {
    color: '#B8B8B8 !important',
    '&.Mui-checked': {
        color: '#6D79EC !important',
    }
};

const formLabelSx = {
    '& .MuiFormControlLabel-label': {
        color: '#b8b8b8 !important',
    }
};

const Projeto = ({ camposDesabilitados, onKeyDown }) => {
    const { control, watch, formState: { errors } } = useFormContext();
    const nomeTipoProjeto = watch("NomeTipoProjeto");
    const cargaPerturbadora = watch("CargaPerturbadora");

    const mostraRamoAtividade = TIPOS_COM_RAMO_ATIVIDADE.includes(nomeTipoProjeto);
    const mostraLoteamento = TIPOS_COM_LOTEAMENTO.includes(nomeTipoProjeto);
    const mostraQuantidadeMedidores = TIPOS_COM_QUANTIDADE_MEDIDORES.includes(nomeTipoProjeto);
    const mostraCargaInstaladaEAInstalar = TIPOS_COM_CARGA_INSTALADA_E_A_INSTALAR.includes(nomeTipoProjeto);
    const mostraPrazoLigacaoDefinitiva = TIPOS_COM_PRAZO_LIGACAO_DEFINITIVA.includes(nomeTipoProjeto);
    const mostraAumentoEPerturbadora = TIPOS_COM_AUMENTO_E_PERTURBADORA.includes(nomeTipoProjeto);

    return (
        <div style={{ width: "100%", minHeight: "405px" }}>
            <div className={styles['campos-grid']}>
                <Controller
                    name="DemandaCalculada"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} >
                            <InputLabel htmlFor="analiseprojeto-demandacalculada" shrink sx={{ color: "#b8b8b8" }}>Demanda calculada (kVA)</InputLabel>
                            <WhiteInput
                                fullWidth
                                placeholder="Demanda calculada"
                                type="number"
                                id="analiseprojeto-demandacalculada"
                                name="DemandaCalculada"
                                {...field}
                                readOnly={!camposDesabilitados}
                                onKeyDown={onKeyDown}
                                className={`${errors?.DemandaCalculada ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.DemandaCalculada ? (
                                <HelperText text={errors?.DemandaCalculada?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />

                {mostraRamoAtividade && (
                    <Controller
                        name="RamoAtividade"
                        control={control}
                        render={({ field }) => (
                            <FormControl variant="outlined" className={styles['campos-m']} >
                                <InputLabel htmlFor="analiseprojeto-ramoatividade" shrink sx={{ color: "#b8b8b8" }}>Ramo de atividade final</InputLabel>
                                <WhiteInput
                                    fullWidth
                                    placeholder="Ramo de atividade"
                                    type="text"
                                    id="analiseprojeto-ramoatividade"
                                    name="RamoAtividade"
                                    {...field}
                                    readOnly={!camposDesabilitados}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.RamoAtividade ? styles.campoComValorErrado : ""}`}
                                />
                                {errors?.RamoAtividade ? (
                                    <HelperText text={errors?.RamoAtividade?.message} />
                                ) : ''}
                            </FormControl>
                        )}
                    />
                )}

                {mostraLoteamento && (
                    <Controller
                        name="NomeLoteamento"
                        control={control}
                        render={({ field }) => (
                            <FormControl variant="outlined" className={styles['campos-m']} >
                                <InputLabel htmlFor="analiseprojeto-nomeloteamento" shrink sx={{ color: "#b8b8b8" }}>Nome do loteamento</InputLabel>
                                <WhiteInput
                                    fullWidth
                                    placeholder="Nome do loteamento"
                                    type="text"
                                    id="analiseprojeto-nomeloteamento"
                                    name="NomeLoteamento"
                                    {...field}
                                    readOnly={!camposDesabilitados}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.NomeLoteamento ? styles.campoComValorErrado : ""}`}
                                />
                                {errors?.NomeLoteamento ? (
                                    <HelperText text={errors?.NomeLoteamento?.message} />
                                ) : ''}
                            </FormControl>
                        )}
                    />
                )}

                {mostraLoteamento && (
                    <Controller
                        name="QuantidadeLotes"
                        control={control}
                        render={({ field }) => (
                            <FormControl variant="outlined" className={styles['campos-m']} >
                                <InputLabel htmlFor="analiseprojeto-quantidadelotes" shrink sx={{ color: "#b8b8b8" }}>Quantidade de lotes</InputLabel>
                                <WhiteInput
                                    fullWidth
                                    placeholder="Quantidade de lotes"
                                    type="number"
                                    id="analiseprojeto-quantidadelotes"
                                    name="QuantidadeLotes"
                                    {...field}
                                    readOnly={!camposDesabilitados}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.QuantidadeLotes ? styles.campoComValorErrado : ""}`}
                                />
                                {errors?.QuantidadeLotes ? (
                                    <HelperText text={errors?.QuantidadeLotes?.message} />
                                ) : ''}
                            </FormControl>
                        )}
                    />
                )}

                {mostraQuantidadeMedidores && (
                    <Controller
                        name="QuantidadeMedidoresUC"
                        control={control}
                        render={({ field }) => (
                            <FormControl variant="outlined" className={styles['campos-m']} >
                                <InputLabel htmlFor="analiseprojeto-quantidademedidoresuc" shrink sx={{ color: "#b8b8b8" }}>Quantidade de medidores/UC</InputLabel>
                                <WhiteInput
                                    fullWidth
                                    placeholder="Quantidade de medidores/UC"
                                    type="number"
                                    id="analiseprojeto-quantidademedidoresuc"
                                    name="QuantidadeMedidoresUC"
                                    {...field}
                                    readOnly={!camposDesabilitados}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.QuantidadeMedidoresUC ? styles.campoComValorErrado : ""}`}
                                />
                                {errors?.QuantidadeMedidoresUC ? (
                                    <HelperText text={errors?.QuantidadeMedidoresUC?.message} />
                                ) : ''}
                            </FormControl>
                        )}
                    />
                )}

                {mostraCargaInstaladaEAInstalar && (
                    <Controller
                        name="CargaInstaladaExistente"
                        control={control}
                        render={({ field }) => (
                            <FormControl variant="outlined" className={styles['campos-m']} >
                                <InputLabel htmlFor="analiseprojeto-cargainstaladaexistente" shrink sx={{ color: "#b8b8b8" }}>Carga instalada existente (kW)</InputLabel>
                                <WhiteInput
                                    fullWidth
                                    placeholder="Carga instalada existente"
                                    type="number"
                                    id="analiseprojeto-cargainstaladaexistente"
                                    name="CargaInstaladaExistente"
                                    {...field}
                                    readOnly={!camposDesabilitados}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.CargaInstaladaExistente ? styles.campoComValorErrado : ""}`}
                                />
                                {errors?.CargaInstaladaExistente ? (
                                    <HelperText text={errors?.CargaInstaladaExistente?.message} />
                                ) : ''}
                            </FormControl>
                        )}
                    />
                )}

                {mostraCargaInstaladaEAInstalar && (
                    <Controller
                        name="CargaAInstalar"
                        control={control}
                        render={({ field }) => (
                            <FormControl variant="outlined" className={styles['campos-m']} >
                                <InputLabel htmlFor="analiseprojeto-cargaainstalar" shrink sx={{ color: "#b8b8b8" }}>Carga a instalar (kW)</InputLabel>
                                <WhiteInput
                                    fullWidth
                                    placeholder="Carga a instalar"
                                    type="number"
                                    id="analiseprojeto-cargaainstalar"
                                    name="CargaAInstalar"
                                    {...field}
                                    readOnly={!camposDesabilitados}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.CargaAInstalar ? styles.campoComValorErrado : ""}`}
                                />
                                {errors?.CargaAInstalar ? (
                                    <HelperText text={errors?.CargaAInstalar?.message} />
                                ) : ''}
                            </FormControl>
                        )}
                    />
                )}

                {mostraPrazoLigacaoDefinitiva && (
                    <Controller
                        name="PrazoLigacaoDefinitiva"
                        control={control}
                        render={({ field }) => (
                            <FormControl variant="outlined" className={styles['campos-m']} >
                                <InputLabel htmlFor="analiseprojeto-prazoligacaodefinitiva" shrink sx={{ color: "#b8b8b8" }}>Prazo para ligação definitiva (meses)</InputLabel>
                                <WhiteInput
                                    fullWidth
                                    placeholder="Prazo para ligação definitiva"
                                    type="number"
                                    id="analiseprojeto-prazoligacaodefinitiva"
                                    name="PrazoLigacaoDefinitiva"
                                    {...field}
                                    readOnly={!camposDesabilitados}
                                    onKeyDown={onKeyDown}
                                    className={`${errors?.PrazoLigacaoDefinitiva ? styles.campoComValorErrado : ""}`}
                                />
                                {errors?.PrazoLigacaoDefinitiva ? (
                                    <HelperText text={errors?.PrazoLigacaoDefinitiva?.message} />
                                ) : ''}
                            </FormControl>
                        )}
                    />
                )}

                <Controller
                    name="ArtCivil"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2 }} >
                            <InputLabel htmlFor="analiseprojeto-artcivil" shrink sx={{ color: "#b8b8b8" }}>ART cívil</InputLabel>
                            <ArtCivil
                                field={field}
                                placeholder="ART cívil"
                                id="analiseprojeto-artcivil"
                                name="ArtCivil"
                                readOnly={!camposDesabilitados}
                                disabled={!camposDesabilitados}
                                onKeyDown={onKeyDown}
                                className={`${errors?.ArtCivil ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.ArtCivil ? (
                                <HelperText text={errors?.ArtCivil?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />

                <Controller
                    name="ArtEletrica"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2 }} >
                            <InputLabel htmlFor="analiseprojeto-arteletrica" shrink sx={{ color: "#b8b8b8" }}>ART elétrica</InputLabel>
                            <ArtEletrica
                                field={field}
                                placeholder="ART elétrica"
                                id="analiseprojeto-arteletrica"
                                name="ArtEletrica"
                                readOnly={!camposDesabilitados}
                                disabled={!camposDesabilitados}
                                onKeyDown={onKeyDown}
                                className={`${errors?.ArtEletrica ? styles.campoComValorErrado : ""}`}
                            />
                            {errors?.ArtEletrica ? (
                                <HelperText text={errors?.ArtEletrica?.message} />
                            ) : ''}
                        </FormControl>
                    )}
                />

                {mostraAumentoEPerturbadora && (
                    <div className={styles['campos-checkbox-linha']}>
                        <div>
                            <Controller
                                name="CargaPerturbadora"
                                control={control}
                                render={({ field }) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={!!field.value}
                                                onChange={(e) => field.onChange(e.target.checked)}
                                                disabled={!camposDesabilitados}
                                                sx={checkboxSx}
                                            />
                                        }
                                        label="Possui carga perturbadora"
                                        sx={formLabelSx}
                                    />
                                )}
                            />

                            {cargaPerturbadora && (
                                <Controller
                                    name="DescricaoCargaPerturbadora"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel htmlFor="analiseprojeto-descricaocargaperturbadora" shrink sx={{ color: "#b8b8b8" }}></InputLabel>
                                            <WhiteInput
                                                fullWidth
                                                placeholder="Descrição da carga perturbadora"
                                                type="text"
                                                id="analiseprojeto-descricaocargaperturbadora"
                                                name="DescricaoCargaPerturbadora"
                                                {...field}
                                                readOnly={!camposDesabilitados}
                                                onKeyDown={onKeyDown}
                                                className={`${errors?.DescricaoCargaPerturbadora ? styles.campoComValorErrado : ""}`}
                                            />
                                            {errors?.DescricaoCargaPerturbadora ? (
                                                <HelperText text={errors?.DescricaoCargaPerturbadora?.message} />
                                            ) : ''}
                                        </FormControl>
                                    )}
                                />
                            )}
                        </div>

                        <div>
                            <Controller
                                name="AumentoCarga"
                                control={control}
                                render={({ field }) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={!!field.value}
                                                onChange={(e) => field.onChange(e.target.checked)}
                                                disabled={!camposDesabilitados}
                                                sx={checkboxSx}
                                            />
                                        }
                                        label="Aumento de carga"
                                        sx={formLabelSx}
                                    />
                                )}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export { Projeto }
